import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bd0e953c")

_pushScopeId("data-v-bd0e953c")
const _hoisted_1 = { class: "p-col-8 p-input-icon-left" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.dialogVisible,
    modal: true,
    class: "kn-dialog--toolbar--primary",
    closable: false,
    style: _ctx.userAttributesLovValueDialogDescriptor.style
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.attribute.attributeName), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-save",
            class: "p-button-text p-button-rounded p-button-plain",
            disabled: _ctx.buttonDisabled,
            onClick: _ctx.handleSubmit,
            "data-test": "submit-button"
          }, null, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.closeDialog
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.lovValues,
        selection: _ctx.selectedLovValues,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedLovValues = $event)),
        dataKey: "id",
        responsiveLayout: "scroll",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
        filterDisplay: "row",
        globalFilterFields: _ctx.userAttributesLovValueDialogDescriptor.globalFilterFields
      }, {
        header: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_InputText, {
              class: "kn-material-input p-col-12",
              type: "text",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              placeholder: _ctx.$t('common.search'),
              badge: "0",
              "data-test": "search-input"
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            selectionMode: _ctx.selectionMode,
            dataKey: "id",
            exportable: false
          }, null, 8, ["selectionMode"]),
          _createVNode(_component_Column, {
            field: "value",
            header: "Value",
            sortable: true
          })
        ]),
        _: 1
      }, 8, ["value", "selection", "filters", "globalFilterFields"])
    ]),
    _: 1
  }, 8, ["visible", "style"]))
})